// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trn-page {
  background: var(--bv-bg-cream);
  min-height: 60vh;
  overflow-x: clip;
  --trn-sticky-top: calc(76px + var(--bv-space-4));
}

.trn-hero {
  position: relative;
  overflow: hidden;
  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);
  background: linear-gradient(
    165deg,
    var(--bv-bg) 0%,
    var(--bv-primary-50) 45%,
    var(--bv-bg-cream) 100%
  );
  border-bottom: 1px solid var(--bv-line-soft);
}

.trn-hero__inner {
  position: relative;
  z-index: 1;
}

.trn-hero__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: clamp(1rem, 2vw, 1.75rem);
  align-items: center;
}

.trn-hero__visual {
  width: 100%;
  min-width: 0;
  line-height: 0;
  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.12s both;
}

.trn-hero__img {
  display: block;
  width: 100%;
  height: auto;
  max-width: none;
  object-fit: contain;
  object-position: center right;
}

.trn-breadcrumb {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: var(--bv-text-sm);
  margin-bottom: var(--bv-space-4);
}

.trn-breadcrumb__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bv-muted);
  font-weight: 500;
  transition: color var(--bv-dur) var(--bv-ease);
}
.trn-breadcrumb__link:hover {
  color: var(--bv-primary-700);
}
.trn-breadcrumb__link i {
  font-size: 0.75rem;
  color: var(--bv-primary);
}

.trn-breadcrumb__sep {
  color: var(--bv-muted-2);
  font-size: 0.65rem;
}

.trn-breadcrumb__current {
  color: var(--bv-ink);
  font-weight: 600;
}

.trn-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  margin-bottom: var(--bv-space-4);
  animation: bvFadeUp 0.6s var(--bv-ease-out) both;
}
.trn-hero__eyebrow i {
  color: var(--bv-primary);
  font-size: 0.85rem;
}

.trn-hero__title {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-4xl);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.12;
  color: var(--bv-ink);
  margin: 0 0 var(--bv-space-4);
  max-width: 16ch;
  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;
}

.trn-hero__lede {
  font-size: var(--bv-text-lg);
  color: var(--bv-muted);
  line-height: 1.65;
  max-width: 48ch;
  margin: 0 0 var(--bv-space-6);
  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;
}

.trn-hero__cta {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 14px 22px 14px 26px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  box-shadow: 0 12px 32px rgba(20, 184, 166, 0.28);
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    filter var(--bv-dur) var(--bv-ease);
  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.15s both;
}
.trn-hero__cta:hover {
  filter: brightness(1.06);
  transform: translateY(-2px);
  box-shadow: 0 18px 44px rgba(20, 184, 166, 0.34);
  color: #fff;
}

.trn-hero__cta-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  transition:
    background var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}
.trn-hero__cta:hover .trn-hero__cta-icon {
  background: rgba(255, 255, 255, 0.36);
  transform: translateX(3px);
}

.trn-listings {
  padding-block: var(--bv-space-7) var(--bv-section-y);
}

.trn-toolbar {
  position: sticky;
  top: var(--trn-sticky-top);
  z-index: 5;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--bv-space-3);
  padding: var(--bv-space-3) var(--bv-space-4);
  margin-bottom: clamp(2rem, 5vw, 3.5rem);
  background: var(--bv-bg);
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  box-shadow:
    0 2px 8px rgba(15, 23, 42, 0.04),
    0 16px 40px rgba(15, 23, 42, 0.06);
}

.trn-toolbar__search {
  flex: 1 1 220px;
  min-width: 200px;
  max-width: 320px;
}

.trn-toolbar__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  flex: 2 1 320px;
  min-width: 0;
}

.trn-toolbar__status {
  min-width: 0;
  margin-left: auto;
  white-space: nowrap;
}

.trn-toolbar__status-line {
  display: block;
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-muted);
  line-height: 1.45;
}

.trn-toolbar__status-line strong {
  font-family: var(--bv-font-display);
  font-weight: 800;
  color: var(--bv-ink);
}

.trn-toolbar__status-line--muted {
  color: var(--bv-muted);
  font-weight: 600;
}

.trn-toolbar__chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 10px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid transparent;
  background: transparent;
  color: var(--bv-muted);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}
.trn-toolbar__chip:hover {
  background: var(--bv-bg-soft);
  color: var(--bv-ink);
}
.trn-toolbar__chip.is-active {
  background: var(--bv-grad-primary);
  color: #fff;
  border-color: var(--bv-primary);
  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.28);
}
.trn-toolbar__chip.is-active .trn-toolbar__chip-icon {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 255, 255, 0.4);
}

.trn-toolbar__chip-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  padding: 4px;
}
.trn-toolbar__chip-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.trn-toolbar__chip-icon i {
  font-size: 0.7rem;
  color: var(--bv-primary);
}

.trn-toolbar__more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-line);
  background: var(--bv-bg-soft);
  color: var(--bv-ink-2);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}
.trn-toolbar__more:hover {
  border-color: var(--bv-primary-line);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}
.trn-toolbar__more i {
  font-size: 0.8rem;
  color: var(--bv-primary);
}

.trn-feed {
  display: flex;
  flex-direction: column;
  gap: clamp(3rem, 6vw, 4.5rem);
}

.trn-card {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: clamp(2rem, 4vw, 3.5rem);
  align-items: center;
  padding: var(--bv-space-2) 0;
}

.trn-card--reverse {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
}

.trn-card--reverse .trn-card__media {
  order: 2;
}

.trn-card--reverse .trn-card__body {
  order: 1;
}

.trn-card__media {
  position: relative;
  z-index: 1;
  width: 100%;
  border-radius: var(--bv-radius-2xl);
  overflow: hidden;
  aspect-ratio: 4 / 3;
  box-shadow:
    0 4px 12px rgba(15, 23, 42, 0.06),
    0 24px 56px rgba(15, 23, 42, 0.12);
  background: linear-gradient(135deg, var(--bv-ink) 0%, #1e3a5f 100%);
}

.trn-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s var(--bv-ease-out);
}
.trn-card:hover .trn-card__media img {
  transform: scale(1.05);
}

.trn-card__badges {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  z-index: 2;
}

.trn-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 6px 8px;
  border-radius: var(--bv-radius-pill);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  color: var(--bv-ink);
  font-family: var(--bv-font-display);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: var(--bv-shadow-xs);
}
.trn-card__badge i,
.trn-card__badge img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}
.trn-card__badge--sport {
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
}
.trn-card__badge--premium {
  background: linear-gradient(135deg, #fde68a 0%, #fbbf24 100%);
  color: var(--bv-ink);
  border: 1px solid rgba(245, 158, 11, 0.35);
}

.trn-card__body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-4);
  min-width: 0;
}

.trn-card__number {
  display: block;
  font-family: var(--bv-font-display);
  font-size: clamp(3rem, 5vw, 4.25rem);
  font-weight: 800;
  line-height: 1;
  color: transparent;
  -webkit-text-stroke: 2px rgba(20, 184, 166, 0.45);
  -webkit-user-select: none;
          user-select: none;
}

.trn-card__title {
  font-family: var(--bv-font-display);
  font-size: clamp(1.5rem, 2.6vw, 2.05rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--bv-ink);
  margin: 0;
  transition: color var(--bv-dur) var(--bv-ease);
}
.trn-card:hover .trn-card__title {
  color: var(--bv-primary-700);
}

.trn-card__meta {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-3);
}

.trn-card__meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--bv-text-base);
  color: var(--bv-ink-3);
  font-weight: 500;
  margin: 0;
}

.trn-card__meta-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.85rem;
}

.trn-card__stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--bv-space-4);
  padding: var(--bv-space-5) 0;
  border-top: 1px solid var(--bv-line-soft);
  border-bottom: 1px solid var(--bv-line-soft);
  max-width: 340px;
}

.trn-card__stat-label {
  display: block;
  font-size: var(--bv-text-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--bv-muted-2);
  margin-bottom: 4px;
}

.trn-card__stat-value {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-xl);
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.02em;
}
.trn-card__stat-value--prize {
  color: var(--bv-primary);
}

.trn-card__cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  align-self: flex-start;
  padding: 10px 16px 10px 18px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-xs);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.26);
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    filter var(--bv-dur) var(--bv-ease);
}
.trn-card__cta:hover {
  filter: brightness(1.06);
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.32);
  color: #fff;
}

.trn-card__cta-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  transition:
    background var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}
.trn-card:hover .trn-card__cta-icon,
.trn-card__cta:hover .trn-card__cta-icon {
  background: rgba(255, 255, 255, 0.36);
  transform: translateX(3px);
}

.trn-stats-bar {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 3vw, 2.5rem);
  padding: var(--bv-space-5) clamp(1.25rem, 4vw, 2.5rem);
  margin-bottom: clamp(2rem, 4vw, 3rem);
  background: linear-gradient(135deg, var(--bv-bg) 0%, var(--bv-primary-50) 130%);
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  box-shadow: var(--bv-shadow-xs);
}

.trn-stats-bar__item {
  display: flex;
  align-items: center;
  gap: var(--bv-space-3);
  flex: 1 1;
  min-width: 0;
}

.trn-stats-bar__icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.28);
}

.trn-stats-bar__value {
  display: block;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-2xl);
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.trn-stats-bar__label {
  display: block;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  font-weight: 500;
}

.trn-stats-bar__divider {
  width: 1px;
  align-self: stretch;
  background: var(--bv-line);
  flex-shrink: 0;
}

.trn-empty {
  margin-top: var(--bv-space-4);
}

@media (max-width: 991.98px) {
  .trn-page {
    --trn-sticky-top: calc(72px + var(--bv-space-3));
  }

  .trn-hero__body {
    grid-template-columns: 1fr;
    gap: var(--bv-space-6);
  }

  .trn-hero__title {
    max-width: none;
    font-size: clamp(1.65rem, 4.5vw, 2.25rem);
  }

  .trn-hero__lede {
    max-width: none;
    font-size: var(--bv-text-base);
  }

  .trn-hero__img {
    object-position: center;
  }

  .trn-toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: var(--bv-space-4);
  }

  .trn-toolbar__search {
    max-width: none;
    width: 100%;
  }

  .trn-toolbar__filters {
    flex: 1 1 auto;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 4px;
    scrollbar-width: none;
  }
  .trn-toolbar__filters::-webkit-scrollbar {
    display: none;
  }

  .trn-toolbar__status {
    margin-left: 0;
    order: 3;
  }

  .trn-toolbar__more {
    align-self: flex-start;
  }

  .trn-card,
  .trn-card--reverse {
    grid-template-columns: 1fr;
    gap: var(--bv-space-5);
  }

  .trn-card--reverse .trn-card__media,
  .trn-card--reverse .trn-card__body {
    order: unset;
  }

  .trn-stats-bar {
    flex-wrap: wrap;
  }

  .trn-stats-bar__divider {
    display: none;
  }

  .trn-stats-bar__item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 1rem);
    min-width: 180px;
  }
}

@media (max-width: 767.98px) {
  .trn-page {
    --trn-sticky-top: calc(64px + var(--bv-space-2));
  }

  .trn-hero {
    padding: 1.15rem 0 1rem;
  }

  .trn-breadcrumb {
    font-size: var(--bv-text-xs);
    margin-bottom: var(--bv-space-3);
  }

  .trn-hero__eyebrow {
    font-size: var(--bv-text-xs);
    padding: 5px 12px;
    margin-bottom: var(--bv-space-3);
  }

  .trn-hero__title {
    font-size: clamp(1.45rem, 7vw, 1.85rem);
    margin-bottom: var(--bv-space-3);
  }

  .trn-hero__lede {
    font-size: var(--bv-text-sm);
    margin-bottom: var(--bv-space-5);
  }

  .trn-hero__cta {
    width: 100%;
    justify-content: center;
  }

  .trn-card__cta {
    width: 100%;
    justify-content: center;
  }

  .trn-card__number {
    font-size: clamp(2.4rem, 12vw, 3.25rem);
  }

  .trn-card__stats {
    max-width: none;
  }

  .trn-feed {
    gap: var(--bv-space-10);
  }

  .trn-stats-bar__item {
    flex: 1 1 100%;
  }
}

@media (hover: none) {
  .trn-card:hover .trn-card__media img {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/tournaments.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE;;;;;GAKC;EACD,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD;;;uCAGqC;EACrC,uDAAuD;AACzD;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;0CAEwC;AAC1C;AACA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,uCAAuC;EACvC,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;EAClC;;sCAEoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;;;;2CAIyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;;;2CAGyC;AAC3C;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uDAAuD;EACvD,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB;;sCAEoC;EACpC,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,8CAA8C;AAChD;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,yCAAyC;EACzC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C;;;uCAGqC;AACvC;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;0CAEwC;AAC1C;AACA;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sDAAsD;EACtD,qCAAqC;EACrC,+EAA+E;EAC/E,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".trn-page {\n  background: var(--bv-bg-cream);\n  min-height: 60vh;\n  overflow-x: clip;\n  --trn-sticky-top: calc(76px + var(--bv-space-4));\n}\n\n.trn-hero {\n  position: relative;\n  overflow: hidden;\n  padding: clamp(1.75rem, 4vw, 3rem) 0 clamp(1.5rem, 3vw, 2.25rem);\n  background: linear-gradient(\n    165deg,\n    var(--bv-bg) 0%,\n    var(--bv-primary-50) 45%,\n    var(--bv-bg-cream) 100%\n  );\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n\n.trn-hero__inner {\n  position: relative;\n  z-index: 1;\n}\n\n.trn-hero__body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n  gap: clamp(1rem, 2vw, 1.75rem);\n  align-items: center;\n}\n\n.trn-hero__visual {\n  width: 100%;\n  min-width: 0;\n  line-height: 0;\n  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.12s both;\n}\n\n.trn-hero__img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-width: none;\n  object-fit: contain;\n  object-position: center right;\n}\n\n.trn-breadcrumb {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: var(--bv-text-sm);\n  margin-bottom: var(--bv-space-4);\n}\n\n.trn-breadcrumb__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--bv-muted);\n  font-weight: 500;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.trn-breadcrumb__link:hover {\n  color: var(--bv-primary-700);\n}\n.trn-breadcrumb__link i {\n  font-size: 0.75rem;\n  color: var(--bv-primary);\n}\n\n.trn-breadcrumb__sep {\n  color: var(--bv-muted-2);\n  font-size: 0.65rem;\n}\n\n.trn-breadcrumb__current {\n  color: var(--bv-ink);\n  font-weight: 600;\n}\n\n.trn-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  margin-bottom: var(--bv-space-4);\n  animation: bvFadeUp 0.6s var(--bv-ease-out) both;\n}\n.trn-hero__eyebrow i {\n  color: var(--bv-primary);\n  font-size: 0.85rem;\n}\n\n.trn-hero__title {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-4xl);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.12;\n  color: var(--bv-ink);\n  margin: 0 0 var(--bv-space-4);\n  max-width: 16ch;\n  animation: bvFadeUp 0.65s var(--bv-ease-out) 0.05s both;\n}\n\n.trn-hero__lede {\n  font-size: var(--bv-text-lg);\n  color: var(--bv-muted);\n  line-height: 1.65;\n  max-width: 48ch;\n  margin: 0 0 var(--bv-space-6);\n  animation: bvFadeUp 0.7s var(--bv-ease-out) 0.1s both;\n}\n\n.trn-hero__cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 22px 14px 26px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 12px 32px rgba(20, 184, 166, 0.28);\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    filter var(--bv-dur) var(--bv-ease);\n  animation: bvFadeUp 0.75s var(--bv-ease-out) 0.15s both;\n}\n.trn-hero__cta:hover {\n  filter: brightness(1.06);\n  transform: translateY(-2px);\n  box-shadow: 0 18px 44px rgba(20, 184, 166, 0.34);\n  color: #fff;\n}\n\n.trn-hero__cta-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.22);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n.trn-hero__cta:hover .trn-hero__cta-icon {\n  background: rgba(255, 255, 255, 0.36);\n  transform: translateX(3px);\n}\n\n.trn-listings {\n  padding-block: var(--bv-space-7) var(--bv-section-y);\n}\n\n.trn-toolbar {\n  position: sticky;\n  top: var(--trn-sticky-top);\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--bv-space-3);\n  padding: var(--bv-space-3) var(--bv-space-4);\n  margin-bottom: clamp(2rem, 5vw, 3.5rem);\n  background: var(--bv-bg);\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  box-shadow:\n    0 2px 8px rgba(15, 23, 42, 0.04),\n    0 16px 40px rgba(15, 23, 42, 0.06);\n}\n\n.trn-toolbar__search {\n  flex: 1 1 220px;\n  min-width: 200px;\n  max-width: 320px;\n}\n\n.trn-toolbar__filters {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  flex: 2 1 320px;\n  min-width: 0;\n}\n\n.trn-toolbar__status {\n  min-width: 0;\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.trn-toolbar__status-line {\n  display: block;\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-muted);\n  line-height: 1.45;\n}\n\n.trn-toolbar__status-line strong {\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.trn-toolbar__status-line--muted {\n  color: var(--bv-muted);\n  font-weight: 600;\n}\n\n.trn-toolbar__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 8px 10px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid transparent;\n  background: transparent;\n  color: var(--bv-muted);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n.trn-toolbar__chip:hover {\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink);\n}\n.trn-toolbar__chip.is-active {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  border-color: var(--bv-primary);\n  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.28);\n}\n.trn-toolbar__chip.is-active .trn-toolbar__chip-icon {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.trn-toolbar__chip-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n  padding: 4px;\n}\n.trn-toolbar__chip-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.trn-toolbar__chip-icon i {\n  font-size: 0.7rem;\n  color: var(--bv-primary);\n}\n\n.trn-toolbar__more {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-line);\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink-2);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n.trn-toolbar__more:hover {\n  border-color: var(--bv-primary-line);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n.trn-toolbar__more i {\n  font-size: 0.8rem;\n  color: var(--bv-primary);\n}\n\n.trn-feed {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(3rem, 6vw, 4.5rem);\n}\n\n.trn-card {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);\n  gap: clamp(2rem, 4vw, 3.5rem);\n  align-items: center;\n  padding: var(--bv-space-2) 0;\n}\n\n.trn-card--reverse {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);\n}\n\n.trn-card--reverse .trn-card__media {\n  order: 2;\n}\n\n.trn-card--reverse .trn-card__body {\n  order: 1;\n}\n\n.trn-card__media {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  border-radius: var(--bv-radius-2xl);\n  overflow: hidden;\n  aspect-ratio: 4 / 3;\n  box-shadow:\n    0 4px 12px rgba(15, 23, 42, 0.06),\n    0 24px 56px rgba(15, 23, 42, 0.12);\n  background: linear-gradient(135deg, var(--bv-ink) 0%, #1e3a5f 100%);\n}\n\n.trn-card__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.7s var(--bv-ease-out);\n}\n.trn-card:hover .trn-card__media img {\n  transform: scale(1.05);\n}\n\n.trn-card__badges {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  z-index: 2;\n}\n\n.trn-card__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px 6px 8px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(8px);\n  color: var(--bv-ink);\n  font-family: var(--bv-font-display);\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  box-shadow: var(--bv-shadow-xs);\n}\n.trn-card__badge i,\n.trn-card__badge img {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n.trn-card__badge--sport {\n  background: rgba(15, 23, 42, 0.72);\n  color: #fff;\n}\n.trn-card__badge--premium {\n  background: linear-gradient(135deg, #fde68a 0%, #fbbf24 100%);\n  color: var(--bv-ink);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n}\n\n.trn-card__body {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-4);\n  min-width: 0;\n}\n\n.trn-card__number {\n  display: block;\n  font-family: var(--bv-font-display);\n  font-size: clamp(3rem, 5vw, 4.25rem);\n  font-weight: 800;\n  line-height: 1;\n  color: transparent;\n  -webkit-text-stroke: 2px rgba(20, 184, 166, 0.45);\n  user-select: none;\n}\n\n.trn-card__title {\n  font-family: var(--bv-font-display);\n  font-size: clamp(1.5rem, 2.6vw, 2.05rem);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--bv-ink);\n  margin: 0;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.trn-card:hover .trn-card__title {\n  color: var(--bv-primary-700);\n}\n\n.trn-card__meta {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-3);\n}\n\n.trn-card__meta-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: var(--bv-text-base);\n  color: var(--bv-ink-3);\n  font-weight: 500;\n  margin: 0;\n}\n\n.trn-card__meta-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 0.85rem;\n}\n\n.trn-card__stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--bv-space-4);\n  padding: var(--bv-space-5) 0;\n  border-top: 1px solid var(--bv-line-soft);\n  border-bottom: 1px solid var(--bv-line-soft);\n  max-width: 340px;\n}\n\n.trn-card__stat-label {\n  display: block;\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--bv-muted-2);\n  margin-bottom: 4px;\n}\n\n.trn-card__stat-value {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-xl);\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.02em;\n}\n.trn-card__stat-value--prize {\n  color: var(--bv-primary);\n}\n\n.trn-card__cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  align-self: flex-start;\n  padding: 10px 16px 10px 18px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.26);\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    filter var(--bv-dur) var(--bv-ease);\n}\n.trn-card__cta:hover {\n  filter: brightness(1.06);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.32);\n  color: #fff;\n}\n\n.trn-card__cta-icon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.22);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n.trn-card:hover .trn-card__cta-icon,\n.trn-card__cta:hover .trn-card__cta-icon {\n  background: rgba(255, 255, 255, 0.36);\n  transform: translateX(3px);\n}\n\n.trn-stats-bar {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 3vw, 2.5rem);\n  padding: var(--bv-space-5) clamp(1.25rem, 4vw, 2.5rem);\n  margin-bottom: clamp(2rem, 4vw, 3rem);\n  background: linear-gradient(135deg, var(--bv-bg) 0%, var(--bv-primary-50) 130%);\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.trn-stats-bar__item {\n  display: flex;\n  align-items: center;\n  gap: var(--bv-space-3);\n  flex: 1;\n  min-width: 0;\n}\n\n.trn-stats-bar__icon {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.28);\n}\n\n.trn-stats-bar__value {\n  display: block;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-2xl);\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.trn-stats-bar__label {\n  display: block;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  font-weight: 500;\n}\n\n.trn-stats-bar__divider {\n  width: 1px;\n  align-self: stretch;\n  background: var(--bv-line);\n  flex-shrink: 0;\n}\n\n.trn-empty {\n  margin-top: var(--bv-space-4);\n}\n\n@media (max-width: 991.98px) {\n  .trn-page {\n    --trn-sticky-top: calc(72px + var(--bv-space-3));\n  }\n\n  .trn-hero__body {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-6);\n  }\n\n  .trn-hero__title {\n    max-width: none;\n    font-size: clamp(1.65rem, 4.5vw, 2.25rem);\n  }\n\n  .trn-hero__lede {\n    max-width: none;\n    font-size: var(--bv-text-base);\n  }\n\n  .trn-hero__img {\n    object-position: center;\n  }\n\n  .trn-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    padding: var(--bv-space-4);\n  }\n\n  .trn-toolbar__search {\n    max-width: none;\n    width: 100%;\n  }\n\n  .trn-toolbar__filters {\n    flex: 1 1 auto;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 4px;\n    scrollbar-width: none;\n  }\n  .trn-toolbar__filters::-webkit-scrollbar {\n    display: none;\n  }\n\n  .trn-toolbar__status {\n    margin-left: 0;\n    order: 3;\n  }\n\n  .trn-toolbar__more {\n    align-self: flex-start;\n  }\n\n  .trn-card,\n  .trn-card--reverse {\n    grid-template-columns: 1fr;\n    gap: var(--bv-space-5);\n  }\n\n  .trn-card--reverse .trn-card__media,\n  .trn-card--reverse .trn-card__body {\n    order: unset;\n  }\n\n  .trn-stats-bar {\n    flex-wrap: wrap;\n  }\n\n  .trn-stats-bar__divider {\n    display: none;\n  }\n\n  .trn-stats-bar__item {\n    flex: 1 1 calc(50% - 1rem);\n    min-width: 180px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .trn-page {\n    --trn-sticky-top: calc(64px + var(--bv-space-2));\n  }\n\n  .trn-hero {\n    padding: 1.15rem 0 1rem;\n  }\n\n  .trn-breadcrumb {\n    font-size: var(--bv-text-xs);\n    margin-bottom: var(--bv-space-3);\n  }\n\n  .trn-hero__eyebrow {\n    font-size: var(--bv-text-xs);\n    padding: 5px 12px;\n    margin-bottom: var(--bv-space-3);\n  }\n\n  .trn-hero__title {\n    font-size: clamp(1.45rem, 7vw, 1.85rem);\n    margin-bottom: var(--bv-space-3);\n  }\n\n  .trn-hero__lede {\n    font-size: var(--bv-text-sm);\n    margin-bottom: var(--bv-space-5);\n  }\n\n  .trn-hero__cta {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .trn-card__cta {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .trn-card__number {\n    font-size: clamp(2.4rem, 12vw, 3.25rem);\n  }\n\n  .trn-card__stats {\n    max-width: none;\n  }\n\n  .trn-feed {\n    gap: var(--bv-space-10);\n  }\n\n  .trn-stats-bar__item {\n    flex: 1 1 100%;\n  }\n}\n\n@media (hover: none) {\n  .trn-card:hover .trn-card__media img {\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
